export function haloEffectTypeToImageSize(gridLayout) {
    switch (gridLayout) {
        case '3-column':
            return { width: 322, height: 154 };
        case '2-column':
            return { width: 210, height: 100 };
        default:
            return { width: 100, height: 100 };
    }
}
